function uptimeDoughnutStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { height } = ownerState;
    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        [breakpoints.up('xxs')]: {
                display: "flex",
                flexDirection: "row",
            backgroundColor: rgba(white.main, 0.8),
            borderRadius: "20px",

            // },
            // [breakpoints.up('md')]: {
            //     display: "flex",
            //     justifyContent: "center",
            //     flexDirection: 'row',
            //     alignItems: "flex-start",
            // },
            // [breakpoints.up('xl')]: {
            // maxHeight: '200px',
            // display: "flex",
            // justifyContent: "center",
            // flexDirection: 'row',
            // alignItems: "flex-start",
            maxHeight: height
        }
    }
}

function uptimeLabelsStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        [breakpoints.up('xxs')]: {

                // width: '100%',
            //     display: 'flex',
            //     flexDirection: 'column',
            //     alignItems: "center",

            //     "& .percent-icon": {
            //         display: 'none',
            //     },

            //     "& .title": {
            //         display: 'flex',
            //         flexDirection: 'column',
            //         alignItems: 'center',
            //         marginLeft: "0px",
            //     },

            //     "& .badgeDots": {
            //         display: "flex",
            //         flexDirection: "column",
            //         alignItems: 'center',
            //         marginTop: pxToRem(4),
            //         marginBottom: pxToRem(4)
            //     }
            // },

            // [breakpoints.up('md')]: {
            width: '50%',
            minWidth: '50% !important',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',

            "& > *": {
                display: "flex",
                alignItems: "flex-start"
            },

            "& .percent-icon": {
                display: 'grid',
            },

            "& .title": {
                paddingLeft: pxToRem(10),
                alignItems: 'flex-start'
            },
            "& .count": {
                paddingLeft: pxToRem(10),
                alignItems: 'flex-start'
            },

            "& .badgeDots": {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginTop: pxToRem(16)
            }
        // },
        // [breakpoints.up('lg')]: {
        //     minWidth: '50%'
        }
    }
}

function uptimeChartStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { height } = ownerState;
    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        [breakpoints.up('xxs')]: {
            //     width: '100%',
            // },
            // [breakpoints.up('x5l')]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
            width: '50%',
            height: '100%',
            maxHeight: height
        }
    }
}

export {
    uptimeDoughnutStyle,
    uptimeLabelsStyle,
    uptimeChartStyle
}